<template>
  <div class="recent-wrap">
    <van-pull-refresh v-model="refreshing" @refresh="handleOnRefreshInfor">
      <van-list v-model="loading" :finished="finished" @load="onLoad">
        <div class="bitTab">
          <van-tabs
            v-model="bidActive"
            @change="changeBid"
            shrink
            class="bottom-tabs"
          >
            <van-tab title="全部"></van-tab>
            <van-tab></van-tab>
            <van-tab></van-tab>
          </van-tabs>
          <div class="total" ref="total" @click="scCilck()">
            <span>{{ total }}</span>
            <AuctionFilter ref="filter-com" @search="search" :type="2" />
          </div>
        </div>

        <div v-if="loading && !list.length" class="content">
          <div class="item" v-for="n in 3" :key="'loading-' + n">
            <div class="item-type-wrapper">
              <div class="item-type">
                <van-skeleton class="vs-type" title />
              </div>
            </div>
            <div class="item-content">
              <van-skeleton class="vs-title" title avatar />
              <van-skeleton class="vs-img" title />
              <van-skeleton class="vs-bottom" title />
            </div>
          </div>
        </div>
        <div class="ad-swiper">
          <van-swipe
            class="my-swipe"
            :autoplay="5000"
            indicator-color="white"
            v-if="adList.length"
          >
            <van-swipe-item
              v-for="(item, i) in adList"
              :key="i"
              @click="handleAdDetailInfor(item, i)"
            >
              <img :src="item.img_url[0]" />
            </van-swipe-item>
          </van-swipe>
        </div>
        <div v-if="renderList.length" class="content">
          <div class="item" v-for="(p, index) in renderList" :key="index">
            <div class="item-type-wrapper">
              <!-- 同步拍>=3场卡片 -->
              <div class="card-swiper-wrap card-radius" v-if="p.type === 2">
                <div class="card-pic" @click="handleInstitutionDetailInfor(p)">
                  <img :src="p.organ_cover || organCoverIcon" />
                  <span>{{ p.organ_name }}</span>
                </div>
                <div class="card-title-wrap">
                  <span class="card-title">{{ p.session_name }}</span
                  ><span class="color-red">{{ p.special_num }}</span>
                </div>
                <div class="show-message">
                  <div class="show-date">{{ p.auction_date }}</div>
                  <div class="card-label-wrap">
                    <span
                      v-for="(label, labelIndex) in p.label_new"
                      :class="[
                        label.style === 1 ? 'label-butie' : '',
                        label.style === 0 ? 'label-baozhengjin' : '',
                      ]"
                      :key="labelIndex"
                      >{{ label.name }}
                    </span>
                  </div>
                </div>
                <div class="aucSwiper" v-if="p.special_list.length">
                  <div class="swiper-wrapper">
                    <div
                      class="swiper-item"
                      v-for="(item, i) in p.special_list"
                    >
                      <div
                        class="swiper-pd"
                        @click="
                          handleHallDetailInfor(
                            (item.type == 1 ? '/special/' : '/session/') +
                              item.source_code +
                              waterLink,
                            item,
                            '8',
                            i
                          )
                        "
                      >
                        <div class="focus-picture">
                          <div class="picture-wrap">
                            <img :src="item.cover_pic" />
                            <template
                              v-if="item.bid_type === 1 || item.bid_type === 2"
                            >
                              <lottie
                                v-if="
                                  item.bid_type === 1 && item.bid_status === 2
                                "
                                class="breathe-wrap"
                                :options="breatheOptions"
                                :height="9.16"
                                :width="4.96"
                              />
                              <div
                                v-if="item.cultural_license"
                                class="tag-wrap"
                              >
                                <lottie
                                  v-if="item.status === 4"
                                  class="tag-wenwu"
                                  :options="jingpaiOptions"
                                  :height="4.62"
                                  :width="3.92"
                                />
                                <lottie
                                  v-if="item.status === 5"
                                  class="tag-wenwu"
                                  :options="jieshuOptions"
                                  :height="4.62"
                                  :width="3.92"
                                />
                                <lottie
                                  v-if="item.status === 1"
                                  class="tag-wenwu"
                                  :options="yuzhanOptions"
                                  :height="4.62"
                                  :width="3.92"
                                />
                              </div>
                              <div class="tag-wrap" v-else>
                                <div
                                  :class="[
                                    'tag-list',
                                    item.bid_type === 1 ? 'tag-tongbu' : '',
                                    item.bid_type === 2 ? 'tag-xianshi' : '',
                                  ]"
                                >
                                  <span class="tag-label"></span>
                                  <!-- 同步拍 -->
                                  <template v-if="item.bid_type === 1">
                                    <!-- 进行中 -->
                                    <span
                                      class="tag-show-Live"
                                      v-if="item.bid_status === 2"
                                      ><img
                                        src="../../../assets/img/list_live.gif"
                                    /></span>
                                    <!-- 拍卖中 即将开始 暂停中 -->
                                    <span
                                      class="tag-show tag-show-paimaizhong"
                                      v-if="
                                        item.bid_status != 2 &&
                                          item.status_text != ''
                                      "
                                      >{{ item.status_text }}</span
                                    >
                                  </template>
                                  <!-- 限时拍 -->
                                  <template
                                    v-if="
                                      item.bid_type === 2 &&
                                        item.status_text != ''
                                    "
                                  >
                                    <span
                                      class="tag-show tag-show-paimaizhong"
                                      >{{ item.status_text }}</span
                                    >
                                  </template>
                                </div>
                              </div>
                            </template>
                          </div>
                          <p class="picture-title">{{ item.auction_date }}</p>
                        </div>
                        <div class="message-wrap">
                          <p class="message-top">{{ item.name }}</p>
                          <!-- <p class="message-bottom">{{ item.organ_name }}</p> -->
                        </div>
                        <div v-if="item.show_bid_label" class="option-wrap">
                          <div
                            :class="[
                              'bidBtn btnIcon',
                              item.bid_type != 1 && item.bid_type != 2
                                ? 'notActivated'
                                : '',
                            ]"
                          >
                            <!-- <lottie v-if="item.bid_type === 1 || item.bid_type === 2" class="svg" :options="heartOptions3" :height="1.2" :width="1.2" /> -->
                            <span
                              v-if="item.bid_type === 1 || item.bid_type === 2"
                              class="click-join"
                              ><i class="icon-hammer"></i>点击参拍</span
                            >
                            <span
                              v-else-if="
                                item.bid_type != 1 && item.bid_type != 2
                              "
                              >暂未开通</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 同步拍=1场卡片 -->
              <div class="card-wrap card-radius" v-else>
                <div
                  class="card-left"
                  @click="
                    handleHallDetailInfor(
                      (p.special_list[0].type == 1
                        ? '/special/'
                        : '/session/') +
                        p.special_list[0].source_code +
                        waterLink,
                      p.special_list[0],
                      '8',
                      index
                    )
                  "
                >
                  <template
                    v-if="
                      p.special_list[0].bid_type === 1 ||
                        p.special_list[0].bid_type === 2
                    "
                  >
                    <lottie
                      v-if="
                        p.special_list[0].bid_type === 1 &&
                          p.special_list[0].bid_status === 2
                      "
                      class="breathe-wrap"
                      :options="breatheOptions"
                      :height="8.62"
                      :width="4.98"
                    />
                    <div
                      v-if="p.special_list[0].cultural_license"
                      class="tag-wrap"
                    >
                      <lottie
                        v-if="p.special_list[0].status === 4"
                        class="tag-wenwu"
                        :options="jingpaiOptions"
                        :height="4.62"
                        :width="3.92"
                      />
                      <lottie
                        v-if="p.special_list[0].status === 5"
                        class="tag-wenwu"
                        :options="jieshuOptions"
                        :height="4.62"
                        :width="3.92"
                      />
                      <lottie
                        v-if="p.special_list[0].status === 1"
                        class="tag-wenwu"
                        :options="yuzhanOptions"
                        :height="4.62"
                        :width="3.92"
                      />
                    </div>
                    <div class="tag-wrap" v-else>
                      <div
                        :class="[
                          'tag-list',
                          p.special_list[0].bid_type === 1 ? 'tag-tongbu' : '',
                          p.special_list[0].bid_type === 2 ? 'tag-xianshi' : '',
                        ]"
                      >
                        <span class="tag-label"></span>
                        <!-- 同步拍 -->
                        <template v-if="p.special_list[0].bid_type === 1">
                          <!-- 进行中 -->
                          <span
                            class="tag-show-Live"
                            v-if="p.special_list[0].bid_status === 2"
                            ><img src="../../../assets/img/list_live.gif"
                          /></span>
                          <!-- 拍卖中 即将开始 暂停中 -->
                          <span
                            class="tag-show tag-show-paimaizhong"
                            v-if="
                              p.special_list[0].bid_status != 2 &&
                                p.special_list[0].status_text != ''
                            "
                            >{{ p.special_list[0].status_text }}</span
                          >
                        </template>
                        <!-- 限时拍 -->
                        <template v-if="p.special_list[0].bid_type === 2">
                          <span class="tag-show tag-show-paimaizhong">{{
                            p.special_list[0].status_text
                          }}</span>
                        </template>
                      </div>
                    </div>
                  </template>
                  <img :src="p.special_list[0].cover_pic" />
                </div>
                <div class="card-right">
                  <div class="card-head">
                    <div
                      class="card-pic"
                      @click="handleInstitutionDetailInfor(p)"
                    >
                      <img :src="p.organ_cover || organCoverIcon" />
                      <span>{{ p.organ_name }}</span>
                    </div>
                    <div class="card-title-wrap overflow-ellipsis">
                      {{ p.special_list[0].name }}
                    </div>
                    <div class="card-label-wrap">
                      <span
                        v-for="(label, labelIndex) in p.label_new"
                        :class="[
                          label.style === 1 ? 'label-butie' : '',
                          label.style === 0 ? 'label-baozhengjin' : '',
                        ]"
                        :key="labelIndex"
                      >
                        <i v-if="label.style != 2">{{ label.name }}</i>
                      </span>
                    </div>
                  </div>
                  <div
                    class="card-foot"
                    @click="
                      handleHallDetailInfor(
                        (p.special_list[0].type == 1
                          ? '/special/'
                          : '/session/') +
                          p.special_list[0].source_code +
                          waterLink,
                        p.special_list[0],
                        '8',
                        index
                      )
                    "
                  >
                    <div class="about-date">
                      <p>{{ p.special_list[0].lot_info }}</p>
                      <p>{{ p.special_list[0].auction_date }}</p>
                    </div>
                    <div class="button-wrap">
                      <div
                        v-if="p.special_list[0].show_bid_label"
                        :class="[
                          'bidBtn btnIcon',
                          p.special_list[0].bid_type != 1 &&
                          p.special_list[0].bid_type != 2
                            ? 'notActivated'
                            : '',
                        ]"
                      >
                        <!-- <lottie v-if="p.special_list[0].bid_type === 1 || p.special_list[0].bid_type === 2" class="svg" :options="heartOptions3" :height="1.2" :width="1.2" /> -->
                        <span class="click-join"
                          ><i
                            :class="[
                              p.special_list[0].bid_type != 1 &&
                              p.special_list[0].bid_type != 2
                                ? ''
                                : 'icon-hammer',
                            ]"
                          ></i
                          >
                            <template v-if="p.special_list[0].bid_type != 1 && p.special_list[0].bid_type != 2">
                              暂未开通
                            </template>
                            <template v-else>点击参拍</template>
                          </span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <EmptyPage v-if="page === 1 && !list.length && !loading" />
        <template #finished v-if="finished">
          <div class="noMore">
            <span>我是有底线的</span>
          </div>
        </template>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
const liveIcon3 = require("../../../assets/img/live_icon_3.json");
const breathe_icon = require("../../../assets/img/json/breathe_icon.json");
const jingpai_icon = require("../../../assets/img/json/jingpai_jin_icon.json");
const jinrijieshu_icon = require("../../../assets/img/json/jinrijieshu_jin_icon.json");
const yuzhan_icon = require("../../../assets/img/json/yuzhan_jin_icon.json");
import EmptyPage from "@/components/empty/emptyPage.vue";
import AuctionFilter from "@/views/preview/component/AuctionFilter.vue";
import lottie from "@/components/common/lottie";
import organCoverIcon from "../../../assets/img/organ_cover_icon.png";

import { scMdFunc } from "@/assets/js/scData";
import { getChangPaiList } from "@/api/preview";

export default {
  name: "recent",
  data() {
    return {
      total: "",
      loading: false,
      finished: false,
      refreshing: false,
      from: "",
      specialDate: "",
      page: 1,
      list: [],
      renderList: [],
      bidActive: 0,
      bid_typeList: [],
      params: {},
      ads: {},
      heartOptions3: {
        animationData: liveIcon3,
        loop: true,
        autoplay: true,
      },
      breatheOptions: {
        animationData: breathe_icon,
        loop: true,
        autoplay: true,
      },
      jingpaiOptions: {
        animationData: jingpai_icon,
        loop: true,
        autoplay: true,
      },
      jieshuOptions: {
        animationData: jinrijieshu_icon,
        loop: true,
        autoplay: true,
      },
      yuzhanOptions: {
        animationData: yuzhan_icon,
        loop: true,
        autoplay: true,
      },
      adList: [],
      waterLink: "",
      hasLoadedFirstPage: false,
      organCoverIcon,
    };
  },
  mounted() {
    if (
      (this.$route.query.from && this.$route.query.from == 1) ||
      this.$route.query.from == 1
    ) {
      this.showWater = true;
      this.waterLink = "?from=" + this.$route.query.from;
    }
    this.onLoad();
  },
  methods: {
    handleOnRefreshInfor() {
      this.page = 1;
      this.finished = false;
      this.loading = true;
      this.onLoad();
    },
    onLoad() {
      let that = this;

      if (!this.hasLoadedFirstPage && this.page === 1) {
        this.hasLoadedFirstPage = true;
      } else if (
        this.hasLoadedFirstPage &&
        this.page === 1 &&
        !this.refreshing
      ) {
        return; // 已经加载过就不重复请求
      }
      getChangPaiList({
        bid_type: this.bidActive,
        special_type: 2,
        page: this.page,
        from: Number(this.from),
        label_date: this.specialDate,
        ...this.params,
      }).then((res) => {
        if (res.code === 0) {
          const result = res.data;
          if (this.refreshing) {
            this.list = [];
            this.renderList = [];
            this.refreshing = false;
          }
          this.adList = result.top_ad_pics;

          this.renderList.push(...result.list);
          this.total = result.special_total;

          this.bid_typeList = result.bid_type;
          this.$nextTick(() => {
            this.loading = false;
            this.page++;

            if (!result.morePage) {
              this.finished = true;
            }
          });
        }
      });
    },
    changeBid() {
      this.page = 1;
      this.from = "";
      this.specialDate = "";
      this.finished = false;
      this.refreshing = true;
      this.loading = true;
      scMdFunc("allClick", {
        cur_page: "19",
        cur_moudle: "19-0",
        cur_button: "19-0-" + Number(this.bidActive + 2),
      });
      this.onLoad();
    },
    search(params) {
      if (params) {
        this.params = params;
      } else {
        this.params = {};
      }
      this.$refs["filter-com"].saveTemp();
      this.$router.push({
        name: "previewSearchUpcoming",
        params,
      });
      // this.list = []
      // this.onRefresh()
    },
    handleInstitutionDetailInfor(item) {
      this.$router.push({
        path: "/organ/" + item.organ_code,
      });
    },
    handleHallDetailInfor(e, item, i, index) {
      // if (item.type == 1) {
      //     scMdFunc('allClick', {
      //         cur_page: '80',
      //         cur_moudle: '1-' + i,
      //         cur_button: '1-' + i + '-' + Number(index + 1),
      //         auction_specia_performance_id_pk: item.special_id,
      //         auction_specia_performance_id: item.special_code,
      //         the_auction_id_pk: item.session_id,
      //         the_auction_id: item.session_code,
      //         auction_company_id: item.organ_id,
      //         auction_company_code: item.organ_code,
      //         auction_state: item.status == 1 ? '待拍卖' : item.status == 2 ? '预展中' : item.status == 3 ? '待预展' : item.status == 4 ? '拍卖中' : item.status == 5 ? '已结拍' : '',
      //         auction_type: item.bid_type
      //     })
      // } else {
      //     scMdFunc('allClick', {
      //         cur_page: '80',
      //         cur_moudle: '1-' + i,
      //         cur_button: '1-' + i + '-' + Number(index + 1),
      //         the_auction_id_pk: item.session_id,
      //         the_auction_id: item.session_code,
      //         auction_company_id: item.organ_id,
      //         auction_company_code: item.organ_code,
      //         auction_state: item.status == 1 ? '待拍卖' : item.status == 2 ? '预展中' : item.status == 3 ? '待预展' : item.status == 4 ? '拍卖中' : item.status == 5 ? '已结拍' : '',
      //         auction_type: item.bid_type,
      //     })
      // }

      this.$router.push({
        path: e,
        query: {
          scId: "",
          scFrom:
            "1-" +
            i +
            "-" +
            Number(index + 1) +
            "-" +
            (item.type == 1 ? item.special_code : "0") +
            "-0",
        },
      });
    },
    handleAdDetailInfor(e, i) {
      scMdFunc("allClick", {
        cur_page: "1",
        cur_moudle: "1-3",
        cur_button: "1-3-" + (Number(i) + 1),
        banner_type_id: e.type,
        banner_order_id: e.orderId,
        banner_advertiser_id: e.advertiserId,
        remarks: e.remarks,
        banner_link_type: e.ad_type,
        banner_link: e.link,
        banner_englishName: e.englishName,
      });

      window.location.href = e.stats_click;
    },
    scCilck() {
      scMdFunc("allClick", {
        cur_page: "21",
        cur_moudle: "21-0",
        cur_button: "21-0-1",
      });
    },
  },
  components: {
    EmptyPage,
    AuctionFilter,
    lottie,
  },
};
</script>
<style scoped lang="scss">
.recent-wrap {
  position: relative;
  .bitTab {
    position: fixed;
    left: 0;
    width: 100%;
    height: 2.3rem;
    z-index: 11;
    background-color: #fff;
    .total {
      position: absolute;
      z-index: 106;
      right: 1.2rem;
      top: 0.8rem;
      font-size: 0.6rem;
    }

    /deep/ .van-tabs.bottom-tabs {
      width: 100%;
      height: 2.4rem;

      > .van-tabs__wrap {
        background: transparent;
        height: 2rem !important;
        border-bottom: 0 !important;
        z-index: 100;
        margin-top: -0.1rem;

        .van-tabs__nav {
          margin: 0.68rem 0.68rem 0.5rem 0.68rem;
          background-color: transparent;

          .van-tab {
            flex: none;
            margin: 0 0.29rem;
            padding: 0;

            .van-tab__text {
              font-size: 0.6rem !important;
              font-family: SF Pro-Regular, SF Pro;
              font-weight: 400;
              color: #6b6c6c;
            }
            &:first-child {
              background: #f5f5f5;
              border-radius: 0.58rem;
              padding: 0.14rem 0.48rem;
              line-height: auto;
              height: 1.3rem;
            }
            &.van-tab--active {
              background: #e8f5ef;
              border-radius: 0.58rem;
              padding: 0.14rem 0.48rem;
              line-height: auto;
              height: 1.3rem;

              .van-tab__text {
                font-size: 0.58rem !important;
                font-weight: bold;
                color: #009b5f;
              }
            }
          }
          .van-tab:nth-child(2) {
            width: 3.83rem;
            height: 1.3rem;
            background-image: url(../../../assets//img/icon_tab_tongbu@2x.png);
            background-size: 100%;
            background-repeat: no-repeat;

            &.van-tab--active {
              background-image: url(../../../assets//img/icon_tab_tongbu_active@2x.png);
            }
          }
          .van-tab:nth-child(3) {
            width: 3.83rem;
            height: 1.3rem;
            background-image: url(../../../assets//img/icon_tab_xianshi@2x.png);
            background-size: 100%;
            background-repeat: no-repeat;
            &.van-tab--active {
              background-image: url(../../../assets//img/icon_tab_xianshi_active@2x.png);
            }
          }

          .van-tabs__line {
            display: none;
          }
        }
      }
      > .van-tabs__content {
        padding: 0 !important;
      }

      .van-tabs__content {
        padding: 2rem 0.8rem 0.8rem;
        position: relative;
        padding-bottom: calc(0.8rem + constant(safe-area-inset-bottom));
        padding-bottom: calc(0.8rem + env(safe-area-inset-bottom));
      }
    }
  }
  .content {
    padding: 0 0.4rem 0.4rem 0.4rem;
  }
  .ad-swiper {
    padding: 2.3rem 0.4rem 0 0.4rem;
    margin: 0rem 0 0.3rem 0;
    img {
      border-radius: 0.6rem;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    /deep/ .van-swipe__indicators {
      bottom: 0.5rem;
    }
    /deep/ .van-swipe__indicator {
      width: 0.2rem;
      height: 0.2rem;
      margin-right: 0.4rem;
      background: #fff;
      opacity: 0.5;
      transition: 0.2s all ease-in-out;
      border-radius: 0.1rem;
    }
    /deep/ .van-swipe__indicator--active {
      opacity: 1;
      width: 0.8rem;
    }
  }
  .item {
    .item-type-wrapper {
      margin-bottom: 0.44rem;
      .card-radius {
        background-color: #fff;
        border-radius: 0.67rem;
        padding: 0.56rem;
        box-sizing: border-box;
        margin-bottom: 0.44rem;
      }
      .card-radius:last-child {
        margin-bottom: 0;
      }
      .card-swiper-wrap {
        .show-message {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .show-date {
            font-size: 0.65rem;
            color: #6b6c6c;
            max-width: 7rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .aucSwiper {
          margin-top: 0.12rem;
          overflow-x: auto;
          width: 100%;
          .swiper-wrapper {
            display: flex;
            margin-left: -0.17rem;
            .swiper-item {
              width: 5.09rem;
              padding: 0.17rem 0.1rem 0.17rem 0.24rem;
              box-sizing: border-box;
              flex-shrink: 0;
              .swiper-pd {
                .focus-picture {
                  position: relative;
                  .picture-wrap {
                    position: relative;
                    .breathe-wrap {
                      position: absolute;
                      top: -1.32rem;
                      left: -0.12rem;
                      width: 5rem;
                      height: 9.2rem;
                      z-index: 10;
                    }
                    > img {
                      height: 6.4rem;
                      display: block;
                      object-fit: cover;
                      border-radius: 0.4rem;
                    }
                    span {
                      display: inline-block;
                      font-weight: bold;
                      font-size: 0.94rem;
                      color: #000;
                    }
                    .tag-wrap {
                      position: absolute;
                      left: 0;
                      top: 0;
                      z-index: 1;
                      width: 100%;
                      height: 1rem;
                      .tag-list {
                        position: relative;
                        .tag-label {
                          width: 1.58rem;
                          height: 0.67rem;
                          display: inline-block;
                          position: absolute;
                          top: 0.25rem;
                          left: 0.25rem;
                          background-size: 100%;
                          background-repeat: no-repeat;
                          z-index: 2;
                        }
                        span {
                          display: block;
                          text-align: center;
                        }
                        .tag-show {
                          position: absolute;
                          top: 0.25rem;
                          left: 1.77rem;
                          height: 0.67rem;
                          border-top-right-radius: 0.21rem;
                          border-bottom-right-radius: 0.21rem;
                          font-size: 0.42rem;
                          font-weight: normal;
                          white-space: nowrap;
                          color: #000;
                          background-color: #fff;
                          padding: 0 0.17rem;
                          z-index: 1;
                        }
                        .tag-show-Live {
                          position: absolute;
                          top: 0.25rem;
                          right: 0.25rem;
                          background-color: #f22c2c;
                          border-radius: 0.24rem;
                          width: 0.83rem;
                          height: 0.83rem;
                          padding: 0;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          img {
                            height: 0.43rem;
                            width: 0.43rem;
                            border-radius: 0;
                            display: block;
                          }
                        }
                      }
                      .tag-tongbu {
                        span.tag-label {
                          background-image: url(../../../assets/img/icon_tongbupai@2x.png);
                        }
                        .tag-show-paimaizhong {
                          border: 0.03rem solid #ff627a;
                        }
                      }
                      .tag-xianshi {
                        span.tag-label {
                          background-image: url(../../../assets/img/icon_xianshipai@2x.png);
                        }
                        .tag-show-paimaizhong {
                          background-color: #fff;
                          position: absolute;
                          top: 0.25rem;
                          left: 1.77rem;
                          height: 0.67rem;
                          border: 0.03rem solid #e4e9f5;
                          border-top-right-radius: 0.21rem;
                          border-bottom-right-radius: 0.21rem;
                          font-size: 0.42rem;
                          font-weight: normal;
                          white-space: nowrap;
                          color: #000;
                          padding: 0 0.17rem;
                          z-index: 1;
                        }
                      }
                      .tag-wenwu {
                        position: absolute;
                        top: -1.72rem;
                        left: 0rem;
                      }
                    }
                  }
                  .picture-title {
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    height: 1.2rem;
                    line-height: 1.2rem;
                    font-size: 0.5rem;
                    padding: 0 0.33rem;
                    color: #fff;
                    background: linear-gradient(
                      180deg,
                      rgba(0, 0, 0, 0) 0%,
                      #000000 100%
                    );
                    border-radius: 0rem 0rem 0.44rem 0.44rem;
                    white-space: nowrap;
                    overflow: hidden;
                  }
                }
                .message-wrap {
                  font-size: 0.7rem;
                  color: #000;
                  white-space: nowrap;
                  overflow: hidden;
                  position: relative;
                  margin-top: 0.2rem;
                  .message-top::after {
                    content: "";
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 40px;
                    height: 100%;
                    background-image: url(../../../assets/img/icon_semi_transparent@2x.png);
                    background-repeat: no-repeat;
                    background-size: 100%;
                  }
                  p.message-bottom {
                    height: 0.75rem;
                    font-size: 0.54rem;
                    color: #6b6c6c;
                  }
                }
                .option-wrap {
                  display: inline-block;
                  position: relative;
                  margin-top: 0.23rem;
                  .btnIcon {
                    height: 1.2rem;
                    line-height: 1.2rem;
                    padding: 0 0.4rem 0 0.4rem;
                    font-size: 0.5rem;
                    border-radius: 1rem;
                    color: #ffffff;
                    .svg {
                      display: inline-block;
                      vertical-align: middle;
                    }
                  }
                  .canpaiBtnIcon {
                    background: #f6344b;
                  }
                  .bidBtn {
                    background: #009b5f;
                  }
                  .notActivated {
                    background-color: #f5f5f5;
                    color: #949596;
                    padding: 0 0.5rem;
                  }
                }
              }
            }
          }
        }
        .aucSwiper::-webkit-scrollbar {
          display: none;
        }

        .aucSwiper .swiper-wrapper {
          display: flex;
        }

        .aucSwiper .swiper-slide {
          width: 12rem;
          margin-left: 0.5rem;
        }

        .aucSwiper a {
          display: block;
        }
      }
      .card-wrap {
        display: flex;
        .card-left {
          width: 4.75rem;
          position: relative;
          margin-right: 0.67rem;
          img {
            width: 100%;
            height: 6.4rem;
            display: block;
            object-fit: cover;
            border-radius: 0.4rem;
          }
          .breathe-wrap {
            position: absolute;
            top: -1.04rem;
            left: -0.12rem;
            width: 5rem;
            height: 9.2rem;
            z-index: 10;
          }
          .tag-wrap {
            position: relative;
            z-index: 4;
            .tag-list {
              position: relative;
              .tag-label {
                width: 1.58rem;
                height: 0.67rem;
                display: inline-block;
                position: absolute;
                top: 0.25rem;
                left: 0.25rem;
                background-size: 100%;
                background-repeat: no-repeat;
                z-index: 2;
              }
              span {
                display: block;
                text-align: center;
              }
              .tag-show {
                position: absolute;
                top: 0.25rem;
                left: 1.77rem;
                height: 0.67rem;
                border-top-right-radius: 0.21rem;
                border-bottom-right-radius: 0.21rem;
                font-size: 0.42rem;
                font-weight: normal;
                white-space: nowrap;
                color: #000;
                background-color: #fff;
                padding: 0 0.17rem;
                z-index: 1;
              }
              .tag-show-Live {
                position: absolute;
                top: 0.25rem;
                right: 0.37rem;
                background-color: #f22c2c;
                border-radius: 0.24rem;
                width: 0.83rem;
                height: 0.83rem;
                padding: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                img {
                  height: 0.43rem;
                  width: 0.43rem;
                  border-radius: 0;
                  display: block;
                }
              }
            }
            .tag-tongbu {
              span.tag-label {
                background-image: url(../../../assets/img/icon_tongbupai@2x.png);
              }
              .tag-show-paimaizhong {
                border: 0.03rem solid #ff627a;
              }
            }
            .tag-xianshi {
              span.tag-label {
                background-image: url(../../../assets/img/icon_xianshipai@2x.png);
              }
              .tag-show-paimaizhong {
                background-color: #fff;
                position: absolute;
                top: 0.25rem;
                left: 1.77rem;
                height: 0.67rem;
                border: 0.03rem solid #e4e9f5;
                border-top-right-radius: 0.21rem;
                border-bottom-right-radius: 0.21rem;
                font-size: 0.42rem;
                font-weight: normal;
                white-space: nowrap;
                color: #000;
                padding: 0 0.17rem;
                z-index: 1;
              }
            }
            .tag-wenwu {
              position: absolute;
              top: -1.72rem;
              left: 0rem;
            }
          }
        }
        .card-right {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          flex-grow: 1;
          .card-foot {
            display: flex;
            align-self: flex-end;
            width: 100%;
            justify-content: space-between;
            .about-date {
              font-size: 0.6rem;
              color: #6b6c6c;
              max-width: 7rem;
              p {
                white-space: nowrap;
                overflow: hidden;
              }
            }
            .button-wrap {
              display: inline-block;
              position: relative;
              display: flex;
              align-self: flex-end;
              .btnIcon {
                height: 1.2rem;
                line-height: 1.2rem;
                padding: 0 0.4rem 0 0.4rem;
                font-size: 0.5rem;
                border-radius: 1rem;
                color: #ffffff;
                .svg {
                  display: inline-block;
                  vertical-align: middle;
                }
              }
              .canpaiBtnIcon {
                background: #f6344b;
              }
              .bidBtn {
                background: #009b5f;
              }
              .notActivated {
                background-color: #f5f5f5;
                color: #949596;
                padding: 0 0.5rem;
              }
            }
          }
        }
      }
      .card-pic {
        display: flex;
        align-items: center;
        img {
          display: block;
          width: 1.1rem;
          height: 1.1rem;
          border-radius: 50%;
          margin-right: 0.3rem;
        }
        span {
          font-size: 0.85rem;
          font-weight: bold;
          color: #000;
        }
      }
      .card-title-wrap {
        margin-top: 0.22rem;
        font-size: 0.7rem;
        color: #000;
        display: flex;
        justify-content: space-between;
        align-items: end;
        span {
          display: inline-block;
          border-radius: 2rem;
          font-size: 0.7rem;
          padding: 0.05rem 0.3rem;
        }
        span.card-title {
          display: inline-block;
          max-width: 13rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          padding-left: 0;
        }
        span.color-red {
          border: 0.06rem solid rgba(0, 155, 95, 0.4);
          color: #009b5f;
        }
        span.color-green {
          border: 0.06rem solid rgba(0, 155, 95, 0.4);
          color: #009b5f;
        }
        &.overflow-ellipsis {
          display: block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 11rem;
        }
      }
      .card-label-wrap {
        display: flex;
        margin-top: 0.15rem;
        span {
          display: inline-block;
          border-radius: 0.15rem;
          font-size: 0.5rem;
          margin-right: 0.3rem;
        }
        span:last-child {
          margin-right: 0;
        }
        span.label-butie {
          color: #fff;
          padding: 0.12rem 0.2rem 0.08rem 0.2rem;
          background: linear-gradient(to right, #fb9c57, #ff0000);
        }
        span.lable-green {
          background-color: #e8f5ef;
          color: #009b5f;
        }
        span.label-baozhengjin {
          border: 0.02rem solid rgba(0, 0, 0, 0.2);
          color: #6b6c6c;
          padding: 0.12rem 0.2rem 0.08rem 0.2rem;
        }
      }
    }
    .item-content-wrapper {
      width: calc(100% - 2.65rem);
    }

    .item-content {
      width: 100%;
      background: #ffffff;
      box-shadow: 0 0.2rem 1.2rem 0 rgba(0, 0, 0, 0.03);
      border-radius: 1.2rem;
      padding: 0.65rem 0.5rem 1rem;
      margin-bottom: 0.8rem;
      .vs-title {
        padding: 0 0.1rem;

        .van-skeleton__avatar {
          width: 1.6rem;
          height: 1.6rem;
          margin-right: 0.4rem;
        }

        .van-skeleton__content {
          width: 4.2rem;
          height: 1.6rem;
          padding: 0;

          .van-skeleton__title {
            width: 100%;
            height: 100%;
          }
        }
      }

      .vs-img {
        padding: 0;
        height: 9.6rem;
        border-radius: 1rem;
        margin: 0.5rem 0;
        overflow: hidden;

        .van-skeleton__title {
          width: 100%;
          height: 100%;
        }
      }

      .vs-bottom {
        padding: 0 0.1rem;
        width: 9.86rem;
        height: 2rem;

        .van-skeleton__title {
          width: 100%;
          // height: 100%;
        }
      }
    }
    .click-join {
      display: flex;
      align-items: center;
      i.icon-hammer {
        width: 0.65rem;
        height: 0.65rem;
        display: inline-block;
        background-image: url(../../../assets/img/icon_hammer@2x.png);
        background-size: 0.65rem 0.65rem;
        background-repeat: no-repeat;
        margin-right: 0.1rem;
      }
    }
  }
  .noMore {
    margin-top: 0.6rem;
    text-align: center;
    font-size: 0.65rem;
    color: #cccccc;
    padding-bottom: 0.6rem;

    span {
      position: relative;
      display: inline-block;
      padding: 0 0.5rem;

      &::before,
      &::after {
        content: "";
        position: absolute;
        width: 2.5rem;
        height: 0.05rem;
        background: #dddee3;
        top: 50%;
        transform: translateY(-50%);
      }

      &::before {
        left: 100%;
      }

      &::after {
        right: 100%;
      }
    }
  }
}
</style>
